import { useEffect, useState } from "react";

export default function ImageInterpolation({ img, style, className }) {
  const transitionDuration = 800;
  const getImageURL = (name) => `/images/Gallery/${name}.jpg`;

  const init = img ?? "figuresLARGE";
  const [lastImage, setLastImage] = useState(init);
  const [newImage, setNewImage] = useState(init);

  useEffect(() => {
    if (!img || img === lastImage) return;
    setNewImage(img);
    const t = setTimeout(() => setLastImage(img), transitionDuration);
    return () => clearTimeout(t);
  }, [img, lastImage]);

  return (
    <div
      className={`d-flex justify-content-center ${className ?? ""}`}
      style={{
        position: "relative",
        borderRadius: 30,
        overflow: "hidden",
        width: "100%",
        height: "100%",
        ...style, // <-- your passed width/height land here
      }}
    >
      <img
        src={getImageURL(newImage)}
        alt={`new: ${newImage}`}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transition: `opacity ${transitionDuration}ms ease-in-out`,
          opacity: lastImage !== newImage ? 1 : 0,
          zIndex: 1,
          borderRadius: 30,
        }}
      />
      <img
        src={getImageURL(lastImage)}
        alt={`old: ${lastImage}`}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          borderRadius: 30,
        }}
      />
    </div>
  );
}
